import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import CardContent from 'material-ui/Card/CardContent';
import Card from 'material-ui/Card';
import Button from 'material-ui/Button';
import CardActions from 'material-ui/Card/CardActions'
import CloseIcon from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton/IconButton';
import Typography from 'material-ui/Typography';
import green from 'material-ui/colors/green';
import Portal from 'material-ui/Portal'
import SaveIcon from 'material-ui-icons/Save';
import { CircularProgress } from 'material-ui/Progress';
import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import { ajaxPost } from '../ajax';


const styles = theme => ({
    title:
    {
        color:"white",
        flex:1,
        marginTop:20,
    },
    card:
        {
            margin: 10
        },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        '&:hover': {
          backgroundColor: green[700],
        },
      },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
      dialog:
      {
          margin:"20px 20px 40px 20px"
      },
      tdCaption:
      {
          width:150,
          padding:10,
          borderBottom:'1px solid #F0F0F0'
      },
      tdValue:
      {
          width:300,
          padding:10,
          borderBottom:'1px solid #F0F0F0'
      }
});


class ViewProfile extends Component {
    state =
        {
            employee: null,
            loading:true,
        }

    componentDidMount = () =>
    {
        ajaxPost({
            url:'/EmployeeAPI/LoadByUsername',
            data:global.userName,
            onSuccess: resp =>
            {
                this.setState({employee:resp});
                this.setState({loading:false});
            },
            finally:()=>{}
        });
            
    }


    render() {
        const { classes } = this.props;

        return (
            <div>
                
            <Portal container={this.props.toolbar}>
                <Typography variant="title" color="inherit" className={classes.title}>
                My Profile
                </Typography>
                <div className={classes.wrapper}>
                    <IconButton disabled={this.state.saving}  className={classes.button} color="inherit" 
                    onClick={this.props.onCloseForm}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </Portal>

            {!this.state.loading ?
            <Card>
                <CardContent>
                    <table>
                    {
                            [
                                { cap: "AIMS ID", prop: "EmployeeNo" },
                                { cap: "Username", prop: "Username" },
                                { cap: "LastName", prop: "LastName" },
                                { cap: "FirstName", prop: "FirstName" },
                                { cap: "MiddleName", prop: "MiddleName" },
                                { cap: "User Type", prop: "RoleType" },
                                { cap: "Department", prop: "Department" },
                                { cap: "Position", prop: "Position" },
                                { cap: "Location", prop: "Location" },
                                { cap: "Company", prop: "Company" },
                                { cap: "Access Group", prop: "AccessGroup" },
                                { cap: "Device ID", prop: "AccessNumber" },
                            ]
                            .map(item =>
                                <tr>
                                    <td className={classes.tdCaption}>
                                        <Typography variant='body1'>{item.cap}</Typography>
                                    </td>
                                    <td className={classes.tdValue}>
                                        <Typography variant='body2'>{this.state.employee[item.prop]}</Typography>
                                    </td>
                                </tr>
                            )
                    }
                    </table>
                </CardContent>
            </Card>
            :
            <CircularProgress/>
            }
            </div>
        )
    }
}
export default withStyles(styles)(ViewProfile);



// WEBPACK FOOTER //
// ./src/admin/ViewProfile.js